import { reducerWithInitialState } from 'typescript-fsa-reducers'

import {
  requestFailed,
  requestFinished,
  requestStarted,
} from './common.actions'
import { ActionCall } from '@professocial/professocialTypes/types/commonTypes'
import { produce } from 'immer'

export interface CommonState {
  requests: ActionCall[]
}

const INITIAL_STATE: CommonState = {
  requests: [],
}


export const CommonReducer = reducerWithInitialState(INITIAL_STATE)

  /**
   *  Requests Management
   */
  .case(requestStarted, (state, action) => {
    return produce(state, (draft) => {
      const clearStateRequests = state.requests.filter(request => request.status !== 'success')

      clearStateRequests.push({ type: action.type, status: 'pending', inProgress: true, error: null, id: action.id })
      return { ...state, requests: clearStateRequests }
    })
  })
  .case(requestFinished, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type && request.id === action.id)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'success'
        draft.requests[index].error = null
      }
    })
  })
  .case(requestFailed, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'failed'
        draft.requests[index].error = action.error
      }
    })
  })
